import React, { useEffect } from "react"
import Helmet from 'react-helmet';

const GoogleAds = () => {

  useEffect(() => {
    (window.adsbygoogle = window.adsbygoogle || []).push({})
  })

  return (
    <>
     <Helmet>
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1823040360435904"
          crossOrigin="anonymous"
        />
      </Helmet>

      <ins
        id="all-stats-adsense"
        className="adsbygoogle"
        style={{
          display: 'block'
        }}
        data-ad-client="ca-pub-1823040360435904"
        data-ad-slot="7443119014"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </>
  )
}

export default GoogleAds
